import React from "react";

const SectionTitle = ({ children }) => {
  return (
    <div className="mt-16 mb-4">
      <button className="btn btn-xs rounded-none bg-accent border-none hover:bg-accent">
        {children}
      </button>
    </div>
  );
};

export default SectionTitle;
